import React from 'react';
import { FileText, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const WorkflowTemplates = () => {
  return (
    <div className="workflow-templates" style={{ fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif' }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6">
          <Link 
            to="/workflow/management" 
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-4"
          >
            <ArrowLeft size={20} className="mr-2" />
            Back to Workflow Management
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">Workflow Templates</h1>
          <p className="text-gray-600 mt-2">
            Pre-built workflow templates for common business processes.
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="text-center py-12">
            <div className="bg-orange-100 p-4 rounded-2xl w-fit mx-auto mb-6">
              <FileText size={48} className="text-orange-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Workflow Templates</h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Pre-built workflow templates for common business processes with quick deployment. 
              This feature will be available in v2.0.
            </p>
            
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <p className="text-yellow-800 text-sm">
                <strong>Coming Soon:</strong> Industry-standard workflow templates with 
                customizable parameters and one-click deployment.
              </p>
            </div>

            <button className="bg-orange-600 text-white px-6 py-3 rounded-lg hover:bg-orange-700 transition-colors flex items-center mx-auto">
              <FileText size={20} className="mr-2" />
              Browse Templates
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkflowTemplates;
